import React, { Component } from "react";
import { connect } from "react-redux";
import BaseSelectField, { getOptionValue, getValue } from '../../Base/ui/inputs/SelectField'

class SelectField extends Component {
  handleChange(option) {
    const { root_url, organizationName, resident } = this.props
    if (Array.isArray(option)) {
      const values = option.map((o) => o.value);
      this.props.handleChange(this.props.name, values.length > 0 ? values : null);
    } else {
      if (option && option.value === "add") {
        window.open(`/organizations/${this.props.organizationName}/referrals/new?sender=${root_url}organizations/${organizationName}/residents/${resident.id}&sender_name=${resident.name}`, "_blank")
      } else {
        this.props.handleChange(this.props.name, option ? option.value : null);
      }
    }
  }

  render() {
    const { resource, name, label, col, action, optionValue, options=[], isMulti, value, creatable, filterOption, isValidNewOption} = this.props;
    return(
      <BaseSelectField 
        value={value}
        optionValue={optionValue}
        options={options}
        onChange={this.props.onChange || this.handleChange.bind(this)}
        isClearable={true}
        resource={resource}
        name={name}
        label={label}
        col={col}
        action={action}
        creatable={creatable}
        isMulti={isMulti}
        filterOption={filterOption}
        isValidNewOption={isValidNewOption}
        {...this.props} />
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { resource = "resident", name, options } = ownProps;

  return {
    action: ownProps.action || state.ui.action,
    value: getValue(state, ownProps),
    optionValue: getOptionValue(state, ownProps),
    organizationName: state.organization.name,
    root_url: state.config.root_url,
    resident: state.resident,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    handleChange: (name, value) => dispatch({ type: "UPDATE_RESIDENT", payload: { name, value }})
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectField);